/* TheMeowPicks — The Finder v3.4 page script.
   Ported from the approved prototype (artifact SbqtPF3h2amf6ir4AvMpgt). Engine-facing logic
   (answers, syncQ3 per-need branch, encode/decode, deep-link, analytics) is unchanged.
   Theme adaptations + finalized UX:
   - catalog from the inline <script id="tmp-finder-catalog"> (finder.* metafields), fallback asset;
   - pick card uses real product photography (catalog `image`) with srcset, monogram fallback;
   - Save to wishlist writes to the theme's browser wishlist (localStorage tmp_wishlist_v1, array of
     product handles) so it actually saves and lights the header heart + /pages/wishlist;
   - AUTO-ADVANCE: choosing an answer moves to the next step (step 1 waits for its follow-up; the two
     steps with optional detail chips show a light "Continue" instead, so the chips aren't skipped);
   - "View this piece" CTA (robust label); "See everything for ..." opens a new tab;
   - "Email it to me" (Klaviyo) only when the section toggle is on. */
(function(){
  var inline = document.getElementById('tmp-finder-catalog');
  if (inline) {
    try { var d = JSON.parse(inline.textContent); if (d && d.products && d.products.length) { return start(d.products); } } catch(e){}
  }
  if (window.TMP_FINDER_CATALOG_URL) {
    fetch(window.TMP_FINDER_CATALOG_URL).then(function(r){return r.json();})
      .then(function(d){ start((d && d.products) || []); })
      .catch(function(){ start([]); });
  } else { start([]); }

function start(products){
const F = window.TMPFinder;
if (!F || !products || !products.length) { return; }
const bands = F.computeBands(products);
const TOTAL = 5;
const EMAIL_ENABLED = !!window.TMP_FINDER_EMAIL_ENABLED;
/* steps that carry optional detail chips after the required choice keep a light Continue so the
   chips are never skipped; every other step auto-advances on selection. */
const AUTO = {0:true, 1:false, 2:false, 3:true, 4:true};
const COLL = {scratch:'/collections/scratch',climb:'/collections/climb',sleep:'/collections/sleep',litter:'/collections/litter-boxes'};
const WISHLIST_KEY = 'tmp_wishlist_v1';
const esc = s => String(s==null?'':s).replace(/[&<>"']/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const track = (ev,data) => { window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:'finder_'+ev},data||{})); };

/* ----- state ----- */
const ans={need:null,diag:null,orientation:null,count:null,chips:[],wall:null,enclosure:null,space:[],budget:null,style:null};
let cur=0, result=null, advTimer=null;
const steps=[...document.querySelectorAll('.tmp-finder-step')];
const stepLbl=document.getElementById('tmpfStep'), bar=document.getElementById('tmpfBar'),
      next=document.getElementById('tmpfNext'), back=document.getElementById('tmpfBack'), nav=document.getElementById('tmpfNav');

/* budget options from the catalog's own price distribution */
const bo=document.getElementById('budgetOpts');
bo.innerHTML = bands.map(b=>`<button class="tmp-finder-opt" role="radio" aria-checked="false" data-v="${b.id}"><span class="tmp-finder-dot"></span><span>${esc(b.label)}</span></button>`).join('')
 + `<button class="tmp-finder-opt" role="radio" aria-checked="false" data-v="any"><span class="tmp-finder-dot"></span><span>Show me the right piece<small>Whatever it costs.</small></span></button>`;

/* radios */
document.querySelectorAll('[role="radiogroup"]').forEach(g=>{
  g.addEventListener('click',e=>{
    const b=e.target.closest('.tmp-finder-opt'); if(!b) return;
    g.querySelectorAll('.tmp-finder-opt').forEach(o=>o.setAttribute('aria-checked','false'));
    b.setAttribute('aria-checked','true');
    const key=g.dataset.key, v=b.dataset.v;
    ans[key]=v; track('answer',{question:key,answer:v});
    if(key==='need'){ ans.diag=null; ans.orientation=null;
      document.querySelectorAll('#subDiag .tmp-finder-opt,#subOri .tmp-finder-opt').forEach(o=>o.setAttribute('aria-checked','false'));
      document.getElementById('subDiag').classList.toggle('on',v==='unsure');
      document.getElementById('subOri').classList.toggle('on',v==='scratch');
    }
    if(key==='diag'){ document.getElementById('subOri').classList.toggle('on',v==='scratch'); ans.orientation=null; document.querySelectorAll('#subOri .tmp-finder-opt').forEach(o=>o.setAttribute('aria-checked','false')); }
    if(key==='need'||key==='diag'){ syncQ3(); }
    afterAnswer();
  });
});
/* chips (optional, never auto-advance) */
document.querySelectorAll('[role="group"]').forEach(g=>{
  g.addEventListener('click',e=>{
    const c=e.target.closest('.tmp-finder-chip'); if(!c) return;
    const key=g.dataset.key, v=c.dataset.v, on=c.getAttribute('aria-checked')==='true';
    if(!on && key==='chips' && (v==='kitten'||v==='senior')){ /* mutually exclusive */
      const other=v==='kitten'?'senior':'kitten'; const ob=g.querySelector(`[data-v="${other}"]`); ob.setAttribute('aria-checked','false'); ans.chips=ans.chips.filter(x=>x!==other); }
    c.setAttribute('aria-checked',on?'false':'true');
    ans[key]= on ? ans[key].filter(x=>x!==v) : ans[key].concat(v);
    track('answer',{question:key,answer:ans[key].join('+')||'none'});
  });
});
function effectiveNeed(){ return ans.need==='unsure'?ans.diag:ans.need; }
function syncQ3(){
  const litter=effectiveNeed()==='litter';
  document.getElementById('q3room').hidden=litter;
  document.getElementById('q3litter').hidden=!litter;
  document.getElementById('q3').textContent=litter?'Open or enclosed?':'What will the room allow?';
  document.getElementById('q3sub').textContent=litter?'The one preference that decides between our units.':'Renting and drilling rarely mix. We plan around it.';
  if(litter){ans.wall='no';}else{ans.enclosure=null;}
}
function complete(i){
  if(i===0){ const n=effectiveNeed(); return !!n && (n!=='scratch' || !!ans.orientation); }
  if(i===1) return !!ans.count;
  if(i===2) return effectiveNeed()==='litter' ? !!ans.enclosure : !!ans.wall;
  if(i===3) return !!ans.budget;
  if(i===4) return !!ans.style;
  return false;
}
function clearAdv(){ if(advTimer){ clearTimeout(advTimer); advTimer=null; } }
function fwd(v){ if(next) next.hidden=!v; if(nav) nav.style.display = (cur<TOTAL && ((cur>0) || v)) ? 'flex' : 'none'; }
/* called after a radio selection */
function afterAnswer(){
  if(cur>=TOTAL) return;
  if(!complete(cur)){ fwd(false); return; }
  if(AUTO[cur]){ fwd(false); clearAdv(); advTimer=setTimeout(function(){ advTimer=null; show(cur+1); },220); }
  else { fwd(true); }
}
function show(i){
  clearAdv(); cur=i; steps.forEach((s,k)=>s.classList.toggle('on',k===i));
  const isRes=i===TOTAL;
  stepLbl.textContent=isRes?'':`${i+1} of ${TOTAL}`; bar.style.width=isRes?'100%':`${i/TOTAL*100+100/TOTAL}%`;
  back.style.visibility=i>0&&!isRes?'visible':'hidden';
  if(isRes){ fwd(false); nav.style.display='none'; renderResult(); }
  else { fwd(complete(i)); }
  if(i>0) document.getElementById('tmpfPanel').scrollIntoView({behavior:'smooth',block:'start'});
}
if(next) next.addEventListener('click',()=>{ if(cur===0&&!started){started=true;track('start');} show(cur+1); });
back.addEventListener('click',()=>{ track('back',{from:cur}); show(cur-1); });
let started=false;

/* ----- result ----- */
function answersForEngine(){ const n=effectiveNeed(); return {need:n,orientation:ans.orientation,count:ans.count,chips:ans.chips,wall:n==='litter'?'no':ans.wall,enclosure:n==='litter'?(ans.enclosure||'either'):null,space:ans.space,budget:ans.budget,style:ans.style}; }
function encode(a){ const p=new URLSearchParams(); for(const k in a){ const v=a[k]; if(v==null||(Array.isArray(v)&&!v.length)) continue; p.set(k,Array.isArray(v)?v.join('+'):v);} return p.toString(); }
function decode(str){ const p=new URLSearchParams(str); const a={}; for(const [k,v] of p){ a[k]=(k==='chips'||k==='space')?v.split('+').filter(Boolean):v; } return a; }
function imgUrl(u,w){ return u + (u.indexOf('?')>-1?'&':'?') + 'width=' + w; }
function handleOf(p){ return (p.url||'').split('?')[0].replace(/\/+$/,'').split('/').pop() || p.id; }
function card(p){
  if(p.image){
    const u=p.image;
    return `<div class="tmp-finder-fig tmp-finder-fig--photo"><img src="${esc(imgUrl(u,900))}" srcset="${esc(imgUrl(u,480))} 480w, ${esc(imgUrl(u,800))} 800w, ${esc(imgUrl(u,1200))} 1200w, ${esc(imgUrl(u,1600))} 1600w" sizes="(max-width:920px) 92vw, 46vw" alt="${esc(p.brand)} ${esc(p.name)}" loading="lazy" decoding="async"></div>`;
  }
  return `<div class="tmp-finder-fig"><div class="tmp-finder-fig-inner"><span class="tmp-finder-mono">${esc(p.brand.charAt(0))}</span><span class="tmp-finder-figname">${esc(p.brand)}</span></div></div>`;
}
/* add a handle to the theme's browser wishlist (localStorage tmp_wishlist_v1) */
function wishlistAdd(handle){
  if(!handle) return;
  try{
    var a=JSON.parse(localStorage.getItem(WISHLIST_KEY)||'[]'); if(!Array.isArray(a)) a=[];
    if(a.indexOf(handle)===-1){ a.unshift(handle); localStorage.setItem(WISHLIST_KEY, JSON.stringify(a)); }
    /* light the header heart immediately; the theme's own watcher also refreshes it */
    document.querySelectorAll('.tmp-wish-head').forEach(function(el){ el.classList.add('has-items'); });
  }catch(e){}
}
function renderResult(){
  const a=answersForEngine(); result=F.recommend(products,a,bands);
  const qs=encode(a); try{ history.replaceState(null,'','#finder?'+qs);}catch(e){}
  track('complete',a); const R=document.getElementById('tmpfResult');
  if(!result.pick){
    R.innerHTML=`<div class="tmp-finder-rhead"><h2 class="tmp-finder-rtitle">Not <em>yet</em></h2><button class="tmp-finder-redo" id="tmpfRedo">Start over</button></div><div class="tmp-finder-note">${esc(result.note)}</div>`;
    document.getElementById('tmpfRedo').onclick=reset; track('result_view',{pick:'none'}); return;
  }
  const p=result.pick;
  const keepBlock = EMAIL_ENABLED ? `
   <div class="tmp-finder-keep"><div class="tmp-finder-keept">Keep this pick</div>
     <div class="tmp-finder-keeprow"><input type="email" id="tmpfEmail" placeholder="you@email.com" aria-label="Email address"><button class="tmp-finder-btn tmp-finder-ghost" id="tmpfMail">Email it to me</button></div>
     <div class="tmp-finder-ok" id="tmpfOk"></div>
   </div>` : '';
  R.innerHTML=`
   <div class="tmp-finder-rhead"><h2 class="tmp-finder-rtitle">Our <em>pick</em></h2><button class="tmp-finder-redo" id="tmpfRedo">Start over</button></div>
   ${result.note?`<div class="tmp-finder-note">${esc(result.note)}</div>`:''}
   <div class="tmp-finder-pick">
     ${card(p)}
     <div class="tmp-finder-body">
       <div class="tmp-finder-brand"><span>${esc(p.brand)}</span><span>$${esc(p.price_usd)}</span></div>
       <div class="tmp-finder-name">${esc(p.name)}</div>
       <div class="tmp-finder-lab">Why it fits</div>
       <div class="tmp-finder-why">${esc(p.finder_reason)}${result.why.length?`<ul>${result.why.map(w=>`<li>${esc(w)}</li>`).join('')}</ul>`:''}</div>
       <div class="tmp-finder-lab">Know before you buy</div>
       <div class="tmp-finder-why"><ul>${result.watch.map(w=>`<li>${esc(w)}</li>`).join('')}</ul></div>
       ${result.dims?`<div class="tmp-finder-dims">${esc(result.dims)}</div>`:''}
       <div class="tmp-finder-actions">
         <a class="tmp-finder-btn" href="${esc(p.url)}" target="_blank" rel="noopener" data-ev="pdp">View this piece</a>
         <button class="tmp-finder-btn tmp-finder-ghost" id="tmpfSave">Save to wishlist</button>
       </div>
     </div>
   </div>
   ${result.alternatives.length?`<div class="tmp-finder-alts"><div class="tmp-finder-altkick">Two other strong fits</div><div class="tmp-finder-altrow">
     ${result.alternatives.map(x=>`<a class="tmp-finder-alt" href="${esc(x.product.url)}" target="_blank" rel="noopener" data-ev="alt"><div class="tmp-finder-altname">${esc(x.product.brand)} ${esc(x.product.name)}</div><div class="tmp-finder-altsub">$${esc(x.product.price_usd)}${x.outOfBand?' · outside your range':''}</div><div class="tmp-finder-altdist">${esc(x.distinction)}</div></a>`).join('')}
   </div><a class="tmp-finder-altsub" style="display:block;margin-top:16px;color:#B7A98E;text-decoration:underline;text-underline-offset:4px" href="${esc(COLL[a.need])}" target="_blank" rel="noopener" data-ev="collection">See everything for ${esc(F.NEED_LABEL[a.need])} →</a></div>`:''}
   ${keepBlock}
   <p style="font-size:12.5px;color:var(--tmpf-ink-3);font-weight:300;margin-top:14px">Not quite right? <a href="/#monthly-edit" style="color:var(--tmpf-ink);text-decoration:underline;text-underline-offset:4px" data-ev="edit">See this month's edit</a>.</p>`;
  document.getElementById('tmpfRedo').onclick=reset;
  R.querySelectorAll('[data-ev]').forEach(el=>el.addEventListener('click',()=>track(el.dataset.ev+'_click',{product:el.href})));
  document.getElementById('tmpfSave').onclick=function(){
    track('save',{product:p.id});
    wishlistAdd(handleOf(p));
    this.textContent='Saved to wishlist'; this.classList.add('tmp-finder-saved'); this.disabled=true;
  };
  if(EMAIL_ENABLED){
    var mail=document.getElementById('tmpfMail');
    if(mail) mail.onclick=()=>{ const v=document.getElementById('tmpfEmail').value.trim(); if(!v.includes('@'))return; track('email',{product:p.id});
      try{ window.klaviyo=window.klaviyo||[]; window.klaviyo.push(['identify',{'$email':v,'FinderLastPick':p.name,'FinderLastPickURL':location.href}]); window.klaviyo.push(['track','Finder Pick Saved',{pick:p.name,url:location.href}]); }catch(e){}
      ok("Sent. We'll email this pick to you."); };
  }
  track('result_view',{pick:p.id,alts:result.alternatives.map(x=>x.product.id).join(','),note:!!result.note});
}
function ok(msg){ const o=document.getElementById('tmpfOk'); if(!o)return; o.textContent=msg; o.style.display='block'; }
function reset(){ for(const k in ans) ans[k]=Array.isArray(ans[k])?[]:null; started=false;
  document.querySelectorAll('[aria-checked]').forEach(o=>o.setAttribute('aria-checked','false'));
  document.querySelectorAll('.tmp-finder-sub').forEach(s=>s.classList.remove('on'));
  document.getElementById('q3room').hidden=false; document.getElementById('q3litter').hidden=true;
  document.getElementById('q3').textContent='What will the room allow?';
  document.getElementById('q3sub').textContent='Renting and drilling rarely mix. We plan around it.';
  try{history.replaceState(null,'','#finder');}catch(e){} track('restart'); show(0); }

/* deep link: #finder?need=...&... */
(function(){
  const h=location.hash; const i=h.indexOf('?'); if(i<0) return;
  const a=decode(h.slice(i+1)); if(!a.need) return;
  Object.assign(ans,{need:a.need,orientation:a.orientation||null,count:a.count||'one',chips:a.chips||[],wall:a.wall||'no',enclosure:a.enclosure||null,space:a.space||[],budget:a.budget||'any',style:a.style||'any'});
  track('deeplink',a); show(TOTAL);
})();
track('view'); show(cur===TOTAL?TOTAL:0);
}
})();